export const JOBS_PAGE_SIZE = 20;

export const LIMIT_WARNING_THRESHOLD = 10;

export const HIGHLIGHT_ANIMATION_DURATION_MS = 1500;

export const DAILY_LIMIT_ERROR_MESSAGE = 'Promo roll synth daily limit exceeded';

export const DUPLICATE_TITLE_ERROR_MESSAGE = 'Ролик с таким названием уже существует';

export const DATA_TEST_IDS = {
  modal: 'promo_roll_synth_modal',
  fieldTitle: 'promo_roll_synth_field_title',
  fieldText: 'promo_roll_synth_field_text',
  fieldVoice: 'promo_roll_synth_field_voice',
  fieldBackground: 'promo_roll_synth_field_background',
  buttonGenerate: 'promo_roll_synth_button_generate',
  buttonCreateCampaign: 'promo_roll_synth_button_create_campaign',
  jobItem: (id: string) => `promo_roll_synth_job_${id}`,
  jobCheckbox: (id: string) => `promo_roll_synth_job_checkbox_${id}`,
  jobButtonDelete: (id: string) => `promo_roll_synth_job_delete_${id}`,
  jobButtonRetry: (id: string) => `promo_roll_synth_job_retry_${id}`,
  jobButtonDownload: (id: string) => `promo_roll_synth_job_download_${id}`,
};
